<template>
    <div class="wrap" id="test">
        <div class="close" @click="closePage()"></div>
        <div class="scroll">
            <span></span>
        </div>
        <div class="content" ref="cont1" @mousemove="mouseMove($event)" @mousedown="change_cuizi(2,$event)" @mouseup="change_cuizi(1,$event)">
            <div class="content-box">
                <div class="timer"></div>
                <!-- 每日任务 -->
                <div class="part p1">
                    <div class="part-mate">10分钟及以上有效赛季游戏局</div>
                    <ul class="day-ul">
                        <li :class="'day-li day-li-'+index" v-for="(item,index) in day_list" :key="index">
                            <div class="name">{{item.packet_id==913002?item.task_name:item.packet_id==913001?'每获得一场赛季游戏胜利':'组队进行赛季游戏并获得胜利'}}</div>
                            <div class="img">
                                <img :src="ticket_url" alt title />
                            </div>
                            <div class="info">{{item.packet_id==913002?'1张狂欢券':item.packet_name}}</div>
                            <div class="msg" v-if="item.packet_id==913002">
                                已自动获得：
                                <span>{{item.over_step}}/{{item.total_step}}</span>
                            </div>
                            <div :class="'btn '+ item.status" @click="open_packet(item, index)" v-else></div>
                            <div class="jd" v-if="item.packet_id!=913002">
                                每日限领：
                                <span>{{item.today_sum}}/{{item.packet_id==913001?5:1}}</span>
                            </div>
                        </li>
                    </ul>
                </div>
                <!-- 10秒go -->
                <div class="part p2">
                    <div class="part-mate">
                        <em @click="query_logs()">获取记录</em>
                        <em class="list">奖品列表</em>
                        <div class="tips tips1">
                            <p>
                                <span>奖品列表如下：</span>
                            </p>
                            <p>酒豆（有效期3天）</p>
                            <p>重转符文石*活动（有效期7天）</p>
                            <p>赛季功勋</p>
                            <p>单人挑战卡</p>
                            <p>50%失败赦免卡</p>
                            <p>双倍积分卡</p>
                            <p>连胜挑战卡</p>
                            <p>DOTA皮肤券</p>
                        </div>
                    </div>
                    <ul class="gift-ul" v-if="gift_list.length>0">
                        <li
                            v-for="(item, index) in gift_list"
                            :class="`gift-li gift-li-${index}`"
                            :key="index"
                            :style="[{color: color_list[index].color}, {fontSize: color_list[index].size}]"
                        >{{(item.is_draw==1?'体验':'')+item.msg.split('（')[0]}}</li>
                    </ul>
                    <div class="mouse-box" id="m-box">
                        <span :class="`mouses${index+1} dd`" v-for="(item, index) in 10" :key="index" @click="try_click(item, index)">
                            <div class="miss" :id="`miss${index+1}`"></div>
                            <div class="hole"></div>
                            <div class="mm" :id="`mouses${index+1}`" @click="knock_mouse(item, index, $event)"></div>
                        </span>
                        <span id="cuizi" class="c" :style="{backgroundImage: 'url('+cuiziImg+')'}"></span>
                    </div>
                    <div class="part-mate">
                        我的狂欢券：
                        <span style="padding-right:22px">{{ticket_amount}}</span>免费体验机会：
                        <span>{{chance_amount}}</span>次
                        <div class="question"></div>
                        <div class="tips">
                            <p>
                                <span>首次进入活动可获得5次十秒狂欢体验机会，但不会获得奖品，仅限效果体验。</span>
                            </p>
                        </div>
                    </div>
                    <div id="datetime" class="last-time" v-if="is_game">{{'狂欢倒计时剩：'+ time_last +'秒！快抢'}}</div>
                    <div class="btn" id="st" @click="test()" v-else></div>
                    <div class="part-mate">
                        <span style="font-weight: normal; color: #FFD100">消耗100狂欢券开启1次十秒狂欢，每次最多获得5个奖励</span>
                    </div>
                </div>
            </div>
            <div class="mate-info"></div>
        </div>
        <div class="mark" v-if="pop_show"></div>

        <div :class="'pop '+(pop_show == 1? 'logs': pop_show == 2? 'confirm':'')" v-if="pop_show">
            <div class="close" @click="closePop()"></div>
            <div class="title">{{pop_show==1?'获取记录':pop_show==2?'提示':''}}</div>
            <!-- 历史记录 -->
            <div v-if="pop_show == 1" class="logs-box">
                <div class="logs-title">
                    <p>日期</p>
                    <p>奖励</p>
                </div>
                <div class="logs-scroll">
                    <ul class="logs-ul" v-if="log_list.length>0">
                        <li :class="'clearFix logs-li-' + index" v-for="(item,index) in log_list" :key="index">
                            <p>{{item.create_time.split('+')[0].replace('T', ' ')}}</p>
                            <p>{{item.item_name}}</p>
                        </li>
                    </ul>
                    <p v-else class="kong">暂无数据</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { $scroll } from '../assets/js/scroll'
import { query_my_item, setEndTime, closePage, isToday } from '../utils/common'

export default {
    name: 'test',
    data() {
        return {
            base_url: 'https://hd.09game.com/carnival/',
            ticket_url: require('@/assets/img/top.png'),
            token: this.$route.query.token,
            userId: this.$route.query.token.split('-')[0],
            scroll: null,
            app_id: 91300, // 活动ID
            timer: null, //定时器
            ticket_id: 20140, //狂欢券
            ticket_amount: 0,
            chance_id: 20141, //体验机会
            chance_amount: 0,
            btn_lock: false, //事件锁
            nowTime: new Date(), //当前日期
            cfg_packet: [],
            my_used_packet: [], //我的已使用礼包
            pop_show: 0, //1抽奖记录
            day_list: [],
            is_first: true,
            log_list: [],
            color_list: [
                { color: '#FFFFFF', size: '12px' },
                { color: '#FFFFFF', size: '12px' },
                { color: '#FFFFFF', size: '12px' },
                { color: '#FFFFFF', size: '14px' },
                { color: '#FFFFFF', size: '16px' },
            ],
            gift_list: [],
            time_last: 10,
            is_game: false,
            data_list: [],
            hole_list: [], //地洞数据
            time_pass: 0,
            timespace: 400, //间隔
            timestop: 400, //停留时间
            timesdaojishi: 1000,
            jg: null,
            daoji: null,
            stops: null,
            mouse: null,
            cuiziImg: require('@/assets/img/top.png'),
        }
    },
    async mounted() {
        this.scroll = new $scroll()
        this.scroll.content = $('.content')
        this.scroll.init()
        this.mouse = document.onmousewheel
        // setEndTime('2022-12-13 23:59:59')
        await this.query_app()
        await this.query_my_task()
        await this.query_my_packet()
        await this.query_use_packet()
        this.init_items(this.chance_id)
        this.init_items(this.ticket_id)
        this.initPage()
    },
    methods: {
        closePage,
        // 查询活动相关接口
        query_app() {
            var _this = this
            this.day_list = []

            return Promise.all([this.$http.q_cfg_packet(this.app_id), this.$http.q_cfg_task(this.app_id)]).then(([app_packet, app_task]) => {
				// console.log(11, app_packet);
                if (app_packet.code == 0) {
                    var arr = app_packet.records
                    for (var item of arr) {
                        item.status = ''
                        item.items = []
                        item.name = []
                        item.items_name = ''
                        item.count = 0
                        for (var i = 1; i <= 6; i++) {
                            var obj = item['gift' + i + '_setting']
                            if (obj) {
                                item.items.push(JSON.parse(obj))
                                item.name.push(JSON.parse(obj).name.split('（')[0])
                            }
                        }
                        item.items_name = item.name.join(' + ')
                        if (item.packet_id >= 913001 && item.packet_id <= 913003) {
                            item.count = item.items.length > 0 ? item.items[0].count : 0
                            _this.day_list.push(item)
                        }
                        _this.cfg_packet.push(item)
                    }
                }
                if (app_task.code == 0) {
                    var arr = app_task.records
                    for (var item of arr) {
                        item.status = ''
                        item.over_step = 0
                        for (let day of _this.day_list) {
                            if (day.packet_id == item.packet_id) {
                                day = Object.assign(day, item)
                            }
                        }
                    }
                }

				console.log(this.day_list);
            })
        },
        // 查询我的任务
        query_my_task() {
            var _this = this
            return this.$http.q_my_task(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        for (let day of _this.day_list) {
                            if (day.task_id == item.task_id && isToday(item.create_time)) {
                                day.over_step = item.over_step
                                day.task = item
                            }
                        }
                    }
                }
            })
        },
        // 查询我的礼包
        query_my_packet() {
            var _this = this
            return this.$http.q_my_packet(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    var arr = res.records
                    for (var item of arr) {
                        for (let day of _this.day_list) {
                            if (day.packet_id == item.packet_id) {
                                day.packet = item
                            }
                        }
                    }
                }
            })
        },

        // 查询礼包使用情况
        query_use_packet() {
            let _this = this
            _this.my_used_packet = []
            return this.$http.q_my_packet_use(this.app_id, this.token).then((res) => {
                if (res.code == 0) {
                    let arr = res.records
                    this.my_used_packet = arr
                }
                for (let item of this.day_list) {
                    item.today_sum = 0
                    for (let a of this.my_used_packet) {
                        if (item.packet_id == a.packet_id && this.isToday(a.create_time)) {
                            item.today_sum++
                        }
                    }
                }
            })
        },
        // 重置按钮状态
        initPage() {
            for (let day of this.day_list) {
                let packet = day.packet
                let task = day.task
                if (packet) {
                    if (packet.balance > 0 && packet.expire_days > 0) {
                        day.status = 'get'
                    } else if (packet.balance == 0 && packet.expire_days > 0 && day.today_sum > 0) {
                        day.status = 'over'
                    } else {
                        day.status = ''
                    }
                } else {
                    day.status = ''
                }
            }
        },

        // 领取
        open_packet(item, index) {
            var _this = this
            if (this.btn_lock) {
                return false
            }
            if (item.status != 'get') {
                return false
            }
            var element = `.day-li-${index} .btn`

            this.btn_lock = true
            this.$http.use_packet(item.packet_id, this.token).then((res) => {
                if (res.code == 0) {
                    text = '领取成功'
                    _this.btn_lock = false
                    _this.mate_show(element, text, -45)
                    _this.query_my_packet()
                    _this.query_use_packet()
                    _this.initPage()
                    _this.$forceUpdate()
                    _this.ticket_amount = query_my_item(_this.ticket_id)
                } else {
                    text = res.info ? res.info : '领取失败'
                    _this.btn_lock = false
                    _this.mate_show(element, text, -45)
                }
            })
        },

        init_items(item_id) {
            // 查询我的道具数量
            var amount = 0
            return this.$http.q_my_item(item_id, this.token).then((res) => {
                if (res.code == 0) {
                    amount = res.records[0].amount
                }
                if (item_id === this.chance_id) {
                    this.chance_amount = amount
                } else if (item_id === this.ticket_id) {
                    this.ticket_amount = amount
                }
            })
        },
        // 开始游戏
        start_game() {
            let _this = this
            if (this.btn_lock) {
                return false
            }
            if (this.is_game) {
                return false
            }
            var element = '.p2 .btn'

            this.btn_lock = true
            this.data_list = []
            this.$http.q_hd('OpenCarnival', this.base_url, { token: this.token }).then((res) => {
                if (res.code == 0 && res.msg) {
                    _this.data_list = res.msg
                    _this.init_items(_this.ticket_id)
                    _this.init_items(_this.chance_id)
                    _this.init_hole()
                    _this.gift_list = []
                    _this.btn_lock = false
                    _this.is_game = true
                    _this.start()
                } else {
                    _this.btn_lock = false
                    _this.mate_show(element, res.msg ? res.msg : '无法开启狂欢！', -45)
                }
            })
        },
        init_hole() {
            this.hole_list = []
            for (let i = 1; i <= 10; i++) {
                let hole = { position_id: i, order: '', type: 0, is_click: false }
                this.hole_list.push(hole)
            }
        },
        mouseMove(e) {
            if (this.is_game) {
                // $('.content').addClass('none-c');
                $('#cuizi').css('display', 'block')
                // console.log(e);
                var left = $('#m-box').offset().left
                var top = $('#m-box').offset().top
                var xx = e.pageX - left + 3
                var yy = e.pageY - top - 30
                $('#cuizi')[0].style.left = xx + 'px'
                $('#cuizi')[0].style.top = yy + 'px'
            } else {
                $('#cuizi').css('display', 'none')
                //  $('.content').removeClass('none-c');
            }
        },
        start() {
            if (this.timesdaojishi != 0) {
                //倒计时
                this.daoji = setInterval(() => {
                    if (this.time_last <= 0) {
                        this.end()
                    }
                    this.time_last -= 1
                }, this.timesdaojishi)
            }
            //不等于0就继续
            if (this.timespace != 0) {
                this.jg = setInterval(() => {
                    if (this.time_pass < 10000) {
                        this.time_pass += this.timespace
                        this.showMouse()
                    }
                }, this.timespace)
            }
        },
        change_cuizi(type, e) {
            if (!this.is_game) {
                return false
            }
            if (type == 1) {
                this.cuiziImg = require('@/assets/img/top.png')
                // $('#cuizi').css("background", `url(~@/assets/img/hammer1.png) -43px -4px/ contain no-repeat`);
            } else {
                this.cuiziImg = require('@/assets/img/top.png')
                // $('#cuizi').css("background", `url(~@/assets/img/hammer2.png) 0 -12px/ contain no-repeat`);
            }
        },
        //地鼠出现时间
        showMouse() {
            //不等于0就继续
            if (this.timestop != 0) {
                var dishuNum = [
                    'mouses1',
                    'mouses2',
                    'mouses3',
                    'mouses4',
                    'mouses5',
                    'mouses6',
                    'mouses7',
                    'mouses8',
                    'mouses9',
                    'mouses10',
                ]
                let item = this.data_list[this.time_pass / this.timespace - 1]
                let index = parseInt(item.position_id) - 1
                this.$set(this.hole_list, index, Object.assign(item, { is_click: false }))
                // $(`#${dishuNum[index]}`).css("background-image", "url(~@/assets/img/mouse-"+item.type+".png)");
                $(`#${dishuNum[index]}`).css('display', 'block')
                this.stops = setTimeout(() => {
                    $(`#${dishuNum[index]}`).addClass('show-out')
                    setTimeout(() => {
                        $(`#${dishuNum[index]}`).css('display', 'none')
                        $(`#${dishuNum[index]}`).removeClass('show-out')
                    }, 300)
                }, this.timestop)
            }
        },
        test() {
            let _this = this
            _this.data_list = [
                { type: 1, order: '777', position_id: 7 },
                { type: 2, order: '222', position_id: 5 },
                { type: 2, order: '222', position_id: 7 },
                { type: 4, order: '222', position_id: 3 },
                { type: 1, order: '222', position_id: 10 },
                { type: 3, order: '222', position_id: 4 },
                { type: 1, order: '222', position_id: 2 },
                { type: 1, order: '222', position_id: 6 },
                { type: 4, order: '222', position_id: 3 },
                { type: 1, order: '222', position_id: 7 },
                { type: 4, order: '222', position_id: 5 },
                { type: 2, order: '222', position_id: 7 },
                { type: 1, order: '222', position_id: 1 },
                { type: 1, order: '222', position_id: 3 },
                { type: 4, order: '222', position_id: 10 },
                { type: 3, order: '222', position_id: 4 },
                { type: 3, order: '222', position_id: 2 },
                { type: 2, order: '222', position_id: 6 },
                { type: 1, order: '222', position_id: 3 },
                { type: 2, order: '222', position_id: 7 },
                { type: 3, order: '222', position_id: 4 },
                { type: 3, order: '222', position_id: 2 },
                { type: 2, order: '222', position_id: 6 },
                { type: 1, order: '222', position_id: 3 },
                { type: 2, order: '222', position_id: 7 },
            ]
            _this.init_hole()
            _this.gift_list = []
            _this.is_game = true
            _this.start()
        },
        //结束
        end() {
            //禁用退出游戏键 和开启开始游戏
            this.is_game = false
            this.time_last = 10
            this.time_pass = 0
            window.clearInterval(this.jg)
            window.clearInterval(this.daoji)
            window.clearTimeout(this.stops)
            $('.mm').css('display', 'none')
        },
        try_click(item, index) {
            if (!this.is_game) {
                return false
            }
            if ($(`#mouses${item}`).css('display') == 'block' && this.hole_list[index].is_click === false) {
                $(`#miss${item}`).css('display', 'block')
                setTimeout(() => {
                    $(`#miss${item}`).css('display', 'none')
                }, 300)
            }
        },

        knock_mouse(item, index, e) {
            if (this.gift_list.length < 5) {
                this.open_gift(this.hole_list[index].order)
            } else {
                this.mate_show('.p2 .last-time', '每次最多获得5个奖励', -45)
            }
            //当前的老鼠隐身
            $(e.target).css('display', 'none')
            this.hole_list[index].is_click = true
        },
        // 打地鼠开启福利
        open_gift(order) {
            let _this = this
            if (!this.is_game) {
                return false
            }
            let element = '.p2 .last-time'
            this.$http.q_hd('CarnivalItem', this.base_url, { token: this.token, order: order }).then((res) => {
                if (res.code == 0) {
                    _this.gift_list.push(res)
                } else {
                    _this.mate_show(element, res.msg ? res.msg : '已领取超过5个奖励！', -45)
                }
            })
        },
        // 查询打中记录
        query_logs() {
            let _this = this
            this.log_list = []
            this.$http.q_hd('GetCarnivalLog', this.base_url, { token: this.token }).then((res) => {
                if (res.code == 0 && res.msg) {
                    _this.log_list = res.msg
                } else {
                    _this.log_list = []
                }
                document.onmousewheel = null
                this.pop_show = 1
            })
        },
        closePop() {
            this.pop_show = 0
            document.onmousewheel = this.mouse
        },
        // 小提示(3s后关闭)
        mate_show(element, text, offsetTop) {
            $('.mate-info').html(text)
            var width1 = $(element).width()
            var width = $('.mate-info').width() + 44
            var offWidth = (width1 - width) / 2
            var top = $('.content').offset().top
            var cssTop = $(element).offset().top - top + offsetTop
            var cssLeft = $(element).offset().left + offWidth
            var css = { top: cssTop, left: cssLeft }
            if (this.timer) {
                clearTimeout(this.timer)
            }
            $('.mate-info').show().css(css)
            this.timer = setTimeout(function () {
                $('.mate-info').hide().html('')
            }, 3000)
        },
    },
}
</script>

<style lang="scss" scoped>
@import '@/assets/css/index.scss';
</style>



// WEBPACK FOOTER //
// src/view/test.vue